"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosterTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RosterTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    active: typebox_1.Type.Boolean(),
    firstName: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    roles: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String())),
});
//# sourceMappingURL=roster-transport.js.map